import React from "react"

type setStateCallback<TValue> = { setState: (arg0: TValue) => void }

export class ValueAndPage<TValue> {
    value?: TValue
    // Yes, this is an `any`. No, I don't like it. But Typescript has a breakdown trying to match our callback to the React component types.
    pageFunction: (arg0: any) => React.JSX.Element

    constructor(pageFunction: (arg0: setStateCallback<TValue>) => React.JSX.Element, value?: TValue) {
        this.pageFunction = pageFunction
        this.value = value
    }
}